;(() => {
	const sliderInstances = new WeakMap()

	const getSpaceBetween = (sectionEl, mobile = false) => {
		if (!sectionEl) return mobile ? 16 : 24
		const styles = getComputedStyle(sectionEl)
		const value = styles.getPropertyValue(mobile ? '--gap-mobile' : '--gap')
		const parsed = parseInt(value, 10)
		return Number.isFinite(parsed) ? parsed : mobile ? 16 : 24
	}

	const getVisibleCount = (width, columns) => {
		if (width < 576) return Math.min(2, columns)
		if (width < 750) return Math.min(2, columns)
		if (width < 990) return Math.min(3, columns)
		if (width < 1200) return Math.min(4, columns)
		if (width < 1360) return Math.min(5, columns)
		return columns
	}

	const applySlideWidths = (slider, sectionEl, visible) => {
		const isMobile = sectionEl.getBoundingClientRect().width < 576
		const gap = getSpaceBetween(sectionEl, isMobile)
		const slides = slider.querySelectorAll('.banner-grid__card')
		const containerWidth = slider.clientWidth || sectionEl.getBoundingClientRect().width
		const slideWidth = Math.max(
			0,
			(containerWidth - (visible - 1) * gap) / visible
		)

		slides.forEach((slide) => {
			slide.style.width = `${slideWidth}px`
			slide.style.maxWidth = `${slideWidth}px`
			slide.style.minWidth = `${slideWidth}px`
			slide.style.flexGrow = '0'
			slide.style.flexShrink = '0'
		})
	}

	const initSlider = (slider, sectionEl) => {
		if (sliderInstances.has(slider)) return sliderInstances.get(slider)

		slider.classList.add('swiper')

		const wrapper = slider.querySelector('.banner-grid__grid')
		if (!wrapper) return null

		wrapper.classList.add('swiper-wrapper')

		const slides = slider.querySelectorAll('.banner-grid__card')
		if (!slides.length) return null

		slides.forEach((slide) => {
			slide.classList.add('swiper-slide')
		})

		const columns = Math.max(1, Number(slider.dataset.columns) || 3)
		const width = sectionEl.getBoundingClientRect().width
		const visible = getVisibleCount(width, columns)
		const isMobile = width < 576
		const gap = getSpaceBetween(sectionEl, isMobile)

		applySlideWidths(slider, sectionEl, visible)

		const instance = new Swiper(slider, {
			loop: false,
			slidesPerView: 'auto',
			spaceBetween: gap,
			speed: 400,
			roundLengths: true,
			watchOverflow: true,
			observer: false,
			resizeObserver: false,
			mousewheel: {
				forceToAxis: true,
			},
		})

		sliderInstances.set(slider, {
			instance,
			columns,
			visible,
			gap,
		})

		return sliderInstances.get(slider)
	}

	const updateSlider = (slider, sectionEl, width) => {
		const state = sliderInstances.get(slider)
		if (!state) return

		const visible = getVisibleCount(width, state.columns)
		const isMobile = width < 576
		const gap = getSpaceBetween(sectionEl, isMobile)

		applySlideWidths(slider, sectionEl, visible)
		state.visible = visible
		state.gap = gap
		state.instance.params.spaceBetween = gap
		state.instance.update()
	}

	const destroySlider = (section) => {
		if (!section?.classList?.contains('banner-grid-section')) return

		const slider = section.querySelector('.banner-grid-slider')
		if (!slider) return

		const state = sliderInstances.get(slider)
		if (state?.instance) {
			state.instance.destroy(true, true)
			sliderInstances.delete(slider)
		}

		const slides = section.querySelectorAll('.banner-grid__card')
		const wrapper = section.querySelector('.banner-grid__grid')

		slider.classList.remove('swiper')
		slides.forEach((slide) => {
			slide.classList.remove('swiper-slide')
			slide.style.width = ''
			slide.style.maxWidth = ''
			slide.style.minWidth = ''
			slide.style.flexGrow = ''
			slide.style.flexShrink = ''
		})
		wrapper?.classList.remove('swiper-wrapper')
	}

	const calcHeightButton = (section, width) => {
		const cards = section.querySelectorAll('.banner-grid__card_full-link')
		cards.forEach((card) => {
			const button = card.querySelector('.banner-grid__button')
			let heightButton
			if (button && width >= 750) {
				heightButton =
					button.getBoundingClientRect().height +
					parseFloat(
						window.getComputedStyle(button, null).getPropertyValue('margin-top')
					)
			} else if (width < 750) {
				heightButton = 16
			} else {
				heightButton = 24
			}

			card.style.setProperty('--height-button', `${heightButton}px`)
			const top = card.querySelector('.banner-grid__top')
			const title = card.querySelector('.banner-grid__title-content')
			if (top) top.style.marginBottom = `${heightButton}px`
			else if (title) title.style.marginTop = `${heightButton}px`
		})
	}

	const initSection = (section) => {
		let sectionBannerGrid

		if (document.currentScript) {
			sectionBannerGrid = document.currentScript.parentElement
		} else {
			sectionBannerGrid = section
		}

		if (!sectionBannerGrid) return

		// Theme editor passes the shopify-section wrapper
		if (
			sectionBannerGrid.classList.contains('shopify-section') &&
			!sectionBannerGrid.classList.contains('banner-grid-section')
		) {
			sectionBannerGrid =
				sectionBannerGrid.querySelector('.banner-grid-section') ||
				sectionBannerGrid
		}

		const slider = sectionBannerGrid.querySelector('.banner-grid-slider')
		let resizeTick = null

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries
			const width = entry.contentRect.width

			if (resizeTick) cancelAnimationFrame(resizeTick)
			resizeTick = requestAnimationFrame(() => {
				calcHeightButton(sectionBannerGrid, width)

				if (!slider) return

				if (!sliderInstances.has(slider)) {
					initSlider(slider, sectionBannerGrid)
				} else {
					updateSlider(slider, sectionBannerGrid, width)
				}
			})
		})

		sectionResizeObserver.observe(sectionBannerGrid)
	}

	initSection()

	document.addEventListener('shopify:section:load', function (event) {
		initSection(event.target)
	})

	document.addEventListener('shopify:section:unload', function (event) {
		destroySlider(event.target)
	})
})()
